// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"d917d8fe","514":"aa35ab9c","977":"2a73c8f2"}[chunkId] + ".chunk.js";
};